<template>
  <div
    :id="panelid"
    class="extension-panel-wrapper"
    :data-testid="`extension-panel-${panelid}`"
  >
    <div
      class="extension-panel-overlay"
      @click="$emit('cancel')"
    />

    <overlay-scrollbars
      ref="os"
      class="extension-panel"
      :class="{
        'extension-panel-lg': size === 'xl',
        'extension-panel-s': size === 's',
      }"
      :options="{ scrollbars: { autoHide: 'scroll', autoHideDelay: 400 } }"
    >
      <KeyboardEvents @keyup="escDown" />

      <button
        aria-label="Close"
        class="close"
        type="button"
        @click="$emit('cancel')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 v-if="title">
        {{ title }}
        <hr />
      </h4>
      <div class="padding-bot-panel">
        <slot />
      </div>
      <div
        v-if="show_save"
        class="h-25 w-100 panel-save-container shadow-lg"
        :class="{ 'panel-save-container-lg': size === 'xl' }"
      >
        <IconAction
          v-if="showRewind"
          class="ml-2 mt-5"
          color="primary"
          :tooltip="_('Back')"
          @click="$emit('rewind-form')"
        >
          <i class="fal fa-long-arrow-left fa-3x" />
        </IconAction>
        <b-button
          v-if="show_save && !ro && hide_buttons === false"
          class="pull-right btn-save-panel do-save"
          data-testid="save-button"
          :disabled="okDisabled"
          variant="outline-primary"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="is_save_loading"
            small
          />
          <template v-else>{{ okTitle }}</template>
        </b-button>

        <b-button
          v-if="!ro && hide_buttons === false"
          class="pull-right btn-save-panel"
          data-testid="cancel-button"
          variant="light"
          @click="$emit('cancel')"
          >{{ cancelTitle }}
        </b-button>
        <slot name="footer" />
      </div>
    </overlay-scrollbars>
  </div>
</template>

<script>
import IconAction from '@/components/ui/IconAction.vue'
import KeyboardEvents from '@/components/ui/KeyboardEvents.vue'
import { rootBus } from '@/contexts/shared/event-bus/RootBus'

export default {
  name: 'ExtensionPanel',
  components: { KeyboardEvents, IconAction },
  props: {
    panelid: {
      type: String,
      required: true,
    },
    panelZindex: Number,
    ro: {
      type: Boolean,
      default: false,
    },
    title: String,
    size: String,
    okDisabled: {
      type: Boolean,
      default: false,
    },
    'ok-title': {
      type: String,
    },
    'cancel-disabled': Boolean,
    'cancel-title': {
      type: String,
    },
    show_save: {
      type: Boolean,
      default: true,
    },
    is_save_loading: {
      type: Boolean,
      default: false,
    },
    hide_buttons: {
      type: Boolean,
      default: false,
    },
    showRewind: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openAlert: false,
      open: false,
      data: [],
    }
  },
  mounted() {
    rootBus.on('panel:reopen', this.onPanelReOpen)
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    rootBus.off('panel:reopen', this.onPanelReOpen)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    onPanelReOpen: function (panel_id) {
      if (this.panelid === panel_id) {
        this.show()
      }
    },
    show() {
      const _this = this
      if (this.$refs.os && this.panelid === 'help') {
        this.$refs.os.osInstance().scroll({ y: 0 }, 1000)
      }
      const panel = document.getElementById(this.panelid)
      if (!panel.classList.contains('active')) {
        panel.classList.add('active')
        _this.escDown(panel)
      }
      rootBus.emit('panel:open')
    },
    hide() {
      const panel = document.getElementById(this.panelid)
      panel.classList.remove('active')
    },
    handleScroll(event) {
      const _this = this
      if (!event || !event.path || event.path.length < 1) {
        return
      }
      if (event.path[1].scrollY > 0) {
        $('#' + _this.panelid).addClass('extension-after-scroll')
      } else if (event.path[1].scrollY < 55) {
        $('#' + _this.panelid).removeClass('extension-after-scroll')
      }
      if ($(window).scrollTop() + $(window).height() === $(document).height()) {
        $('#' + _this.panelid).addClass('extension-at-bottom')
      } else {
        $('#' + _this.panelid).removeClass('extension-at-bottom')
      }
    },
    handleSubmit() {
      if (!this.is_save_loading) {
        this.$emit('submit')
      }
    },
    escDown: function (e) {
      const _this = this
      if (e.code === 'Escape') {
        _this.$emit('cancel')
      }
    },
  },
}
</script>

<style scoped>
.extension-panel-overlay {
  position: fixed;
  height: 0;
  width: 100vw;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  transition: opacity 0.4s;
  opacity: 0;
  z-index: 2000;
}

.extension-panel {
  position: fixed;
  top: 0px;
  width: 800px;
  height: 100vh;
  background: #f8f9fa;
  box-shadow: -3px 1px 7px 0px #80808075;
  color: black;
  overflow: auto;
  padding: 1em;
  right: -880px;
  z-index: 2001;
  -webkit-transition: height 0s, top 0.1s, right 0.4s; /* For Safari 3.1 to 6.0 */
  transition: height 0s, top 0.1s, right 0.4s;
}

.extension-panel-lg {
  width: 850px;
  right: -870px;
}

.extension-panel-s {
  width: 430px;
}

.extension-after-scroll .extension-panel {
  top: 0px !important;
}

.extension-at-bottom .extension-panel {
  height: 94.5% !important;
}

.extension-panel-wrapper.active {
  & > .extension-panel-overlay {
    opacity: 1;
    height: 100vh;
  }
  & > .extension-panel {
    right: 0;
  }
}

.padding-bot-panel {
  padding-bottom: 6rem;
}
</style>
